import React from 'react';
import './brands.css';
import bgbrands from '../images/bgbrands.webp';
import ArrowRight from './ArrowRights.js';
import BrandsIcons from './BrandsIcons.js';

function Brands() {
  return (
    <section className='brands' style={{ backgroundImage: `url(${bgbrands})` }} name='clients'>
      <div className='content'>
        <p className='subtitles'>BIG</p>
        <div className='titles'>
            <h2>BRANDS <sub>-</sub></h2>
            <ArrowRight className="custom-arrow" />
            <span className='bajada'>Sabemos que los grandes proyectos requieren compromiso. Nos convertimos en una extensión de tu equipo para <strong>garantizar el éxito en cada etapa del proceso.</strong></span>
        </div>
        <BrandsIcons limit={25} /> 
      </div>
    </section>
  );
}

export default Brands;